var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPageName === 'adx-and-open-bidding')?_c('report-container',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"report-modals",fn:function(){return undefined},proxy:true}],null,false,3715415922)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }